var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconOnChain = function SvgIconOnChain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 111,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-on-chain_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    x: 10,
    fill: "url(#icon-on-chain_svg__b)",
    rx: 21,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#icon-on-chain_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.078 31.719c-4.523 0-8.203 3.68-8.203 8.203s3.68 8.203 8.203 8.203c4.522 0 8.203-3.68 8.203-8.203s-3.68-8.203-8.203-8.203Zm0 11.719c1.25 0 2.418-.674 3.046-1.76a1.165 1.165 0 0 1 1.601-.426c.56.324.752 1.04.427 1.6a5.88 5.88 0 0 1-5.074 2.93 5.866 5.866 0 0 1-5.86-5.86c0-3.23 2.63-5.86 5.86-5.86a5.881 5.881 0 0 1 5.074 2.93 1.172 1.172 0 1 1-2.028 1.173 3.533 3.533 0 0 0-3.046-1.759 3.52 3.52 0 0 0-3.516 3.516 3.52 3.52 0 0 0 3.516 3.516Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.312 25.782c0-.648-.524-1.172-1.172-1.172-4.368 0-8.596-1.28-12.231-3.703l-1.181-.788a1.168 1.168 0 0 0-1.3 0l-1.181.788a21.983 21.983 0 0 1-12.231 3.703 1.17 1.17 0 0 0-1.172 1.172v13.38c0 9.37 5.974 17.737 14.863 20.7a1.17 1.17 0 0 0 .742 0c8.89-2.963 14.863-11.33 14.863-20.7v-13.38ZM50.078 50.469c-5.816 0-10.547-4.731-10.547-10.547 0-5.816 4.731-10.547 10.547-10.547 5.816 0 10.547 4.731 10.547 10.547 0 5.816-4.731 10.547-10.547 10.547Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-on-chain_svg__b",
    x1: 10,
    x2: 90,
    y1: 58,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F56C4E",
    stopOpacity: 0.84
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-on-chain_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30 20h40v40H30z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon-on-chain_svg__a",
    width: 100,
    height: 111,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 11,
    result: "effect1_dropShadow_641_735790"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 21
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.9125 0 0 0 0 0.713268 0 0 0 0 0.585521 0 0 0 0.59 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_641_735790"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_641_735790",
    result: "shape"
  })))));
};
export default SvgIconOnChain;